// src/components/AnonymizationProfilesPage/SaveToDbSection.jsx
import React from 'react';
import {
    Box,
    Typography,
    Paper,
    Switch,
    Stack,
    Avatar,
} from '@mui/material';
import { CloudUploadOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { alpha } from '@mui/material/styles';

const SaveToDbSection = ({ value, onChange }) => {
    const { t } = useTranslation();
    const active = !!value;

    return (
        <Paper
            elevation={0}
            sx={(theme) => ({
                p: 2.5,
                borderRadius: 3,
                backgroundColor: active 
                    ? alpha(theme.palette.primary.main, 0.1) 
                    : 'background.paper',
                border: '1px solid',
                borderColor: active ? 'primary.main' : 'divider',
                transition: 'all 0.3s ease'
            })}
        >
            <Stack direction="row" spacing={2.5} alignItems="center">
                <Avatar 
                    sx={{ 
                        bgcolor: active ? 'primary.main' : 'action.selected', 
                        color: active ? 'primary.contrastText' : 'text.secondary',
                        width: 48,
                        height: 48,
                        transition: 'all 0.3s ease'
                    }}
                >
                    <CloudUploadOutlined />
                </Avatar>

                <Box sx={{ flex: 1 }}>
                    <Typography 
                        variant="subtitle1" 
                        sx={{ 
                            fontWeight: 600, 
                            color: active ? 'primary.main' : 'text.primary' 
                        }}
                    >
                        {t('anonymizationProfiles.saveToDbTitle', 'Uložiť anonymizácie do DB')}
                    </Typography>
                    <Typography 
                        variant="body2" 
                        color="text.secondary"
                    >
                        {t(
                            'anonymizationProfiles.saveToDbDesc',
                            'Uloží pôvodný aj anonymizovaný dokument do databázy pre neskoršie stiahnutie.'
                        )}
                    </Typography>
                </Box>

                <Switch
                    checked={active}
                    color="primary"
                    onChange={(e) => onChange('save_to_db', e.target.checked)}
                />
            </Stack>
        </Paper>
    );
};

export default SaveToDbSection;